<!-- Toolbar -->
@if (showToolbar || token) {
  <mat-toolbar color="primary" class="app-header">
    <div style="z-index: 999; margin: 0 auto; flex: 0 1" class="p-2 mt-3">
      <app-search
        [matchedNav]="matchedNav"
        (search)="onSearch($event)"
        (selectedFilterValue)="onFilterSelected($event)"
        [suggestedFilters]="pageLevelFilters"
        [searchFilteredData]="filteredData"
        (onEnterKeyPressed)="onEnterKeyPressed($event)"
        [panel]="panel"
        (searchTermParam)="searchTerm($event)"
      ></app-search>
    </div>
    <nav class="navbar">
      <!-- Menu Section (If User is Logged In) -->
      <div class="nav-tool-items">
        <!-- Dropdown Trigger -->
        <button mat-button [matMenuTriggerFor]="userMenu" class="username">
          <!-- Hi {{user}} ▼ -->
          <mat-icon>account_circle</mat-icon>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <!-- Dropdown Menu -->
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>person</mat-icon>
            <span class="settings-menu">{{ user }}</span>
          </button>
          <button mat-menu-item (click)="viewProfile()">
            <mat-icon>account_circle</mat-icon>
            <span class="settings-menu">Profile</span>
          </button>
          <!-- TODO: Change Password for future -->
          <!-- <button mat-menu-item (click)="changePassword()">
          <mat-icon>update</mat-icon>
          <span>Change Password</span>
        </button> -->
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span class="settings-menu">Log out</span>
          </button>
        </mat-menu>
      </div>
    </nav>
  </mat-toolbar>
}

<div class="main-content">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>
